var _style, _defs, _rect, _circle, _circle2, _path, _g, _g2, _rect2, _g3, _rect3, _desc;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCitySunny(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-screen sm:w-full ",
    viewBox: "0 0 1200 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* Animaciones de loop infinito */\n    @keyframes cloudMove {\n      0% { transform: translateX(0); }\n      100% { transform: translateX(-1200px); }\n    }\n    @keyframes waveMove {\n      0% { transform: translateX(0); }\n      100% { transform: translateX(-400px); }\n    }\n    @keyframes blink {\n      0%, 100% { opacity: 1; }\n      50% { opacity: 0.3; }\n    }\n\n    .cloud { animation: cloudMove 60s linear infinite; }\n    .waves { animation: waveMove 8s linear infinite; }\n    .window { animation: blink 2s infinite; }\n    .window:nth-child(2n) { animation-delay: 0.5s; }\n    .window:nth-child(3n) { animation-delay: 1s; }\n    .window:nth-child(4n) { animation-delay: 1.5s; }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skySunset",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#66ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#66ccff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reflection",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#66ccff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#66ccff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#66ccff",
    stopOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "url(#skySunset)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 150,
    r: 70,
    fill: "#ffd93b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "65;75;65",
    dur: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#ffd93b;#ffea70;#ffd93b",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 150,
    r: 120,
    fill: "#ffd93b",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "110;130;110",
    dur: "8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.5;0.2",
    dur: "8s",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 500 L200 380 L400 440 L600 360 L800 450 L1000 370 L1200 440 L1200 700 L0 700 Z",
    fill: "#2f3a65",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f4f4f",
    opacity: 0.6,
    transform: "translate(0,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 460,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 470,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 440,
    width: 30,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 455,
    width: 20,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 465,
    width: 15,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 445,
    width: 30,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 460,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 470,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 440,
    width: 30,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 455,
    width: 20,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 465,
    width: 15,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 445,
    width: 30,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 460,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 470,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 440,
    width: 30,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 455,
    width: 20,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 450,
    width: 25,
    height: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd27f",
    className: "window",
    transform: "translate(0,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 465,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 445,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 935,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085,
    y: 460,
    width: 5,
    height: 5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 600,
    width: 1200,
    height: 100,
    fill: "url(#reflection)",
    opacity: 0.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "waves"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 620 Q100 630 200 620 T400 620 T600 620 T800 620 T1000 620 T1200 620              T1400 620 T1600 620",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.3,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 640 Q150 650 300 640 T600 640 T900 640 T1200 640              T1500 640 T1800 640",
    fill: "none",
    stroke: "#ffd27f",
    strokeOpacity: 0.25,
    strokeWidth: 5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 600,
    width: 1200,
    height: 100,
    fill: "#2f4f4f",
    opacity: 0.6
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Horizonte urbano minimalista loopable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "SVG animado de horizonte urbano con nubes, ondas y ventanas animadas en loop infinito perfecto.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitySunny);
export default __webpack_public_path__ + "static/media/city-sunny.87c70bf5f497f556326e5c930c228dff.svg";
export { ForwardRef as ReactComponent };